export const getAllowedPlanBackups = (plan: Plan) => {
  const isBackupRedislabsAllowed =
    plan?.backup_path_type === 'redislabs' || plan?.backup_path_type === 'redislabs_custom';

  const isBackupCustomAllowed =
    plan?.backup_path_type === 'custom' || plan?.backup_path_type === 'redislabs_custom';

  const backupAllowCustomAndDefault = isBackupRedislabsAllowed && isBackupCustomAllowed;

  return { isBackupRedislabsAllowed, isBackupCustomAllowed, backupAllowCustomAndDefault };
};
